import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChannelsandoperationsService } from '../../../../services/channelsandoperations.service';
import { TiposOperacionesService } from '../../../../services/tipos_operaciones.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-editar-tipo-operacion',
  templateUrl: './editar-tipo-operacion.component.html',
  styleUrls: ['./editar-tipo-operacion.component.scss'],
})
export class EditarTipoOperacionComponent implements OnInit {
  form = this.fb.group({
    nombre: [
      '',
      [
        Validators.required,
        Validators.maxLength(50),
      ],
    ],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });
  constructor(
    public dialogRef: MatDialogRef<EditarTipoOperacionComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public canalService: ChannelsandoperationsService,
    public tiposOperacionesService: TiposOperacionesService,
    private _snackBar: MatSnackBar
  ) {}

  ngOnInit(): void {
    this.form.controls.nombre.setValue(this.data.nombre);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onSubmit() {
    this.form.controls.id_usuarios_creador.setValue(
      sessionStorage.getItem('id_usuario')
    );
    this.form.value.id_tipos_operaciones = this.data.id_tipos_operaciones;
    this.form.value.borrado = 0;
    this.tiposOperacionesService
      .actualizar(this.form.value)
      .subscribe((data) => {
        console.log("Respuesta",data);
        this.openSnackBar('Tipo Operación actualizado con éxito', 'x');
        this.dialogRef.close(true);
      },err=>{
        console.log(err.error.payload)
        this.openSnackBar(err.error.payload,'x')
      });
  }
}
